var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 3V4.5H6.75V7.5C6.75097 8.40681 6.98677 9.29791 7.43444 10.0865C7.8821 10.8751 8.52637 11.5344 9.3045 12C8.52637 12.4656 7.8821 13.1249 7.43444 13.9135C6.98677 14.7021 6.75097 15.5932 6.75 16.5V19.5H5.25V21H18.75V19.5H17.25V16.5C17.249 15.5932 17.0132 14.7021 16.5656 13.9135C16.1179 13.1249 15.4736 12.4656 14.6955 12C15.4736 11.5344 16.1179 10.8751 16.5656 10.0865C17.0132 9.29791 17.249 8.40681 17.25 7.5V4.5H18.75V3H5.25ZM8.25 4.5H15.75V7.5C15.75 9.57975 14.0798 11.25 12 11.25C9.92025 11.25 8.25 9.57975 8.25 7.5V4.5ZM12 12.75C14.0798 12.75 15.75 14.4202 15.75 16.5V19.5H15V18C15 16.3425 13.6575 15 12 15C10.3425 15 9 16.3425 9 18V19.5H8.25V16.5C8.25 14.4202 9.92025 12.75 12 12.75Z",
    fill: "#F5C348"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.bee6b142f8130ecdcad2aab62a258d8e.svg";
export { ForwardRef as ReactComponent };